import axios from 'axios';

const authInstance = method => {
  return axios.create({
    baseURL: `https://identitytoolkit.googleapis.com/v1/accounts:${method}?key=${process.env.REACT_APP_API_KEY || "AIzaSyCOaAKbPEU19RbDSEGN5X0Bx-Vzz8FF7BM"}`
  });
};

export default authInstance; 
